import { Icon } from '../Icon';
import { SecondaryButton } from '../primitives/buttons/SecondaryButton';

export function BackButton() {
  return (
    <SecondaryButton w="32px" size="sm" colorScheme="gray">
      <Icon size={6} icon="arrowLeft" color="gray.400" />
    </SecondaryButton>
  );
}